<script setup>
// NOTICE: KAPTION-INTEGRATION
// whatsapp-message-merging — "3 mensajes combinados" under a message that was
// sent as the merge of several held texts (content_attributes.kaption_merge).
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  merge: { type: Object, default: null },
});

const { t } = useI18n();
const count = computed(
  () => Number(props.merge?.sourceCount ?? props.merge?.source_count) || 0
);
</script>

<template>
  <span
    v-if="count > 1 && !merge?.pending"
    class="flex items-center gap-1 px-1 pt-0.5 text-[11px] text-n-slate-11"
    data-testid="kaption-merged-caption"
  >
    <span class="i-lucide-merge size-3" />
    {{ t('KAPTION_MESSAGE_MERGE.BUBBLE.MERGED', { count }) }}
  </span>
</template>
